import * as React from 'react';
import {useTranslation} from "react-i18next";

import {Accordion, AccordionDetails, AccordionSummary, FormControl, FormControlLabel, Radio, RadioGroup, Typography} from "@mui/material";
import {ExpandMore} from "@mui/icons-material";
import {convertPrice} from "../../assets/js/main";
import {useSelector} from "react-redux";
import {useSnackbar} from "notistack";
import HandleFetchData from "../../plugin/HandleFetchData";


export default function Invoice(props) {
  const {t} = useTranslation()
  const {enqueueSnackbar} = useSnackbar();
  const {fetchData} = HandleFetchData()
  const [expanded, setExpanded] = React.useState(0);
  const [payMethods, setPayMethods] = React.useState([]);
  const selector = useSelector((st) => st)
  const [showDetails, setShowDetails] = React.useState(false);

  const handleChange = (event) => {
    props.handlePaymentMethod(event.target.value)
  };

  React.useEffect(() => {
    props?.items?.orderId && getPaymentMethods(props?.items?.orderId)
  }, [props])

  const getPaymentMethods = async (id) => {
    let fetch = await fetchData('', 'GET', '/getPaymentMethod', '',
       "application/json", {
         "orderId": String(id),
         "paymentMethodForId": "1"
       }, '',''
    )
    if (fetch?.Data) {
      setPayMethods(fetch?.Data)
    }
  }

  const handleChangeAccordion = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  }


  const handleItemsPrice = (items) => {
    return items?.AccessPrinterPrice + items?.AgentAddedValue + items?.CartonPrice + items?.CodTranPrice + items?.DistributionPrice + items?.GoodsCodPrice + items?.InsurancePrice + items?.PostexEngPrice + items?.PrintLogoPrice + items?.RegistrationValue + items?.SmsPrice + items?.shipmentHaghemaghar
  }
  const handleItemsTotalPrice = (items) => {
    return items?.AccessPrinterPrice + items?.AgentAddedValue + items?.CartonPrice + items?.CodTranPrice + items?.DistributionPrice + items?.GoodsCodPrice + items?.InsurancePrice + items?.PostexEngPrice + items?.PrintLogoPrice + items?.RegistrationValue + items?.SmsPrice + items?.gatewayPostPrice + items?.shipmentHaghemaghar + items?.gatewayPostPriceTax
  }


  return (
     <>
       {/*<div className="container-fluid">*/}
         <div className="invoicePage">

           { props?.paymentMethod && <div style={{visibility: "hidden", opacity: "0"}} id="isSelectPaymentMethod"/>}

           <div className="row">
             <div className="col-12 col-lg-4 mb-3">
               <div className="paymentInfo">
                 <div className="info">
                   <div className="orderNum">
                     <p>{t("singleOrder.invoice.t2")} :</p>
                     <span>{props?.items?.orderId}</span>
                   </div>
                   <div className="orderTotal">
                     <p>{t("singleOrder.invoice.t13")} :</p>
                     <span>{convertPrice(props?.items?.orderTotal)} {t("singleOrder.invoice.t14")}</span>
                   </div>
                 </div>

                 <FormControl>
                   <RadioGroup
                      aria-labelledby="demo-controlled-radio-buttons-group"
                      name="controlled-radio-buttons-group"
                      value={props?.paymentMethod}
                      onChange={handleChange}
                      id="paymentMethod"
                   >
                     {
                       payMethods?.PaymentMethods?.map((item, index) =>
                          item?.Name !== "بانک سامان" &&  <FormControlLabel value={item?.PaymentMethodSystemName} control={<Radio/>}
                                            label={item?.Name + ' ' + `${item?.PaymentMethodSystemName === "Payments.Wallet"
                                               ? `( ${(payMethods?.RewardPointsBalance ? 
                                                  convertPrice(payMethods?.RewardPointsBalance) : 0) + ' ' + t("singleOrder.invoice.t14")} )` : ''}`}/>
                       )
                     }
                   </RadioGroup>
                 </FormControl>
               </div>

             </div>
             <div className="col-12 col-lg-8">
               <div className="orderInfo">
                 {
                   props?.items?.shipmentsData?.map((item, index) => {
                     return <Accordion key={index} expanded={expanded === index} onChange={handleChangeAccordion(index)}>
                       <AccordionSummary aria-controls={'panel1' + index + 'a-content'}
                                         id={'panel1' + index + 'a-header'}
                                         expandIcon={<ExpandMore/>}>
                         <Typography>{t("singleOrder.invoice.t3") + ' ' + (index + 1)}</Typography>
                       </AccordionSummary>
                       <AccordionDetails>

                         <div className="postService mb-4">
                           <div className="title">
                             <h6>{t("singleOrder.invoice.t4")}</h6>
                           </div>
                           <table>
                             <thead>
                             <tr>
                               {/*<th style={{width: '10%'}}>{t("singleOrder.invoice.t5")}</th>*/}
                               {/*<th style={{width: '10%'}}/>*/}
                               <th style={{width: '50%'}}>{t("singleOrder.invoice.t6")}</th>
                               <th style={{width: '20%'}}/>
                               <th style={{width: '20%'}}>{t("singleOrder.invoice.t8")}</th>
                             </tr>
                             </thead>
                             <tbody>

                             <tr className="bodyTable">
                               {/*<td/>*/}
                               <td>{selector?.multi_sender?.services_name}</td>
                               <td/>
                               <td>{convertPrice(item?.gatewayPostPrice)}</td>
                             </tr>


                             <tr className="bodyTable">
                               {/*<td/>*/}
                               <td>{t("singleOrder.invoice.t20")}</td>
                               <td/>
                               <td>{convertPrice(item?.gatewayPostPriceTax || 0)}</td>
                             </tr>


                             </tbody>
                           </table>
                         </div>


                         <div className="postService">
                           <div className="title">
                             <h6>{t("singleOrder.invoice.t11")}</h6>
                           </div>

                           <table>
                             <thead>
                             <tr>
                               {/*<th style={{width: '10%'}}>{t("singleOrder.invoice.t5")}</th>*/}
                               {/*<th style={{width: '10%'}}/>*/}
                               <th style={{width: '50%'}}>{t("singleOrder.invoice.t6")}</th>
                               <th style={{width: '20%'}}/>
                               <th style={{width: '20%'}}>{t("singleOrder.invoice.t8")}</th>
                             </tr>
                             </thead>
                             <tbody>

                             {
                               showDetails ?
                                  <>
                                    {
                                      item?.AccessPrinterPrice ?
                                         <tr className="bodyTable">
                                           {/*<td/>*/}
                                           <td>{t("singleOrder.invoice.t21")}</td>
                                           <td/>
                                           <td>{convertPrice(item?.AccessPrinterPrice)}</td>
                                         </tr>
                                         : null
                                    }

                                    {
                                      item?.AgentAddedValue ?
                                         <tr className="bodyTable">
                                           {/*<td/>*/}
                                           <td>{t("singleOrder.invoice.t22")}</td>
                                           <td/>
                                           <td>{convertPrice(item?.AgentAddedValue)}</td>
                                         </tr> : null
                                    }

                                    {
                                      item?.CartonPrice ?
                                         <tr className="bodyTable">
                                           {/*<td/>*/}
                                           <td>{t("singleOrder.invoice.t23")}</td>
                                           <td/>
                                           <td>{convertPrice(item?.CartonPrice)}</td>
                                         </tr> : null
                                    }

                                    {
                                      item?.CodTranPrice ?
                                         <tr className="bodyTable">
                                           {/*<td/>*/}
                                           <td>{t("singleOrder.invoice.t24")}</td>
                                           <td/>
                                           <td>{convertPrice(item?.CodTranPrice)}</td>
                                         </tr> : null
                                    }
                                    {
                                      item?.DistributionPrice ?
                                         <tr className="bodyTable">
                                           {/*<td/>*/}
                                           <td>{t("singleOrder.invoice.t25")}</td>
                                           <td/>
                                           <td>{convertPrice(item?.DistributionPrice)}</td>
                                         </tr> : null
                                    }
                                    {
                                      item?.GoodsCodPrice ?
                                         <tr className="bodyTable">
                                           {/*<td/>*/}
                                           <td>{t("singleOrder.invoice.t26")}</td>
                                           <td/>
                                           <td>{convertPrice(item?.GoodsCodPrice)}</td>
                                         </tr> : null
                                    }
                                    {
                                      item?.InsurancePrice ?
                                         <tr className="bodyTable">
                                           {/*<td/>*/}
                                           <td>{t("singleOrder.invoice.t27")}</td>
                                           <td/>
                                           <td>{convertPrice(item?.InsurancePrice)}</td>
                                         </tr> : null
                                    }
                                    {
                                      item?.PostexEngPrice ?
                                         <tr className="bodyTable">
                                           {/*<td/>*/}
                                           <td>{t("singleOrder.invoice.t28")}</td>
                                           <td/>
                                           <td>{convertPrice(item?.PostexEngPrice)}</td>
                                         </tr> : null
                                    }
                                    {
                                      item?.PrintLogoPrice ?
                                         <tr className="bodyTable">
                                           {/*<td/>*/}
                                           <td>{t("singleOrder.invoice.t29")}</td>
                                           <td/>
                                           <td>{convertPrice(item?.PrintLogoPrice)}</td>
                                         </tr> : null
                                    }
                                    {
                                      item?.RegistrationValue ?
                                         <tr className="bodyTable">
                                           {/*<td/>*/}
                                           <td>{t("singleOrder.invoice.t30")}</td>
                                           <td/>
                                           <td>{convertPrice(item?.RegistrationValue)}</td>
                                         </tr> : null
                                    }
                                    {
                                      item?.SmsPrice ?
                                         <tr className="bodyTable">
                                           {/*<td/>*/}
                                           <td>{t("singleOrder.invoice.t31")}</td>
                                           <td/>
                                           <td>{convertPrice(item?.SmsPrice)}</td>
                                         </tr> : null
                                    }
                                    {
                                      item?.shipmentHaghemaghar ?
                                         <tr className="bodyTable">
                                           {/*<td/>*/}
                                           <td>{t("singleOrder.invoice.t32")}</td>
                                           <td/>
                                           <td>{convertPrice(item?.shipmentHaghemaghar)}</td>
                                         </tr> : null
                                    }


                                    {/*<tr className="bodyTable">*/}
                                    {/*  <td/>*/}
                                    {/*  <td/>*/}
                                    {/*  <td>{t("singleOrder.invoice.t9")}</td>*/}
                                    {/*  <td>{convertPrice(handleItemsPrice(item))}</td>*/}
                                    {/*</tr>*/}
                                  </>
                                  : null
                             }

                             <tr className="bodyTable btnBodyTable" onClick={() => setShowDetails(!showDetails)}
                             id="showDetails">
                               {/*<td/>*/}
                               <td>{showDetails ? t("singleOrder.invoice.t9") : t("singleOrder.invoice.t19")}</td>
                               <td/>
                               <td>{convertPrice(handleItemsPrice(item))}</td>
                             </tr>
                             </tbody>
                           </table>

                         </div>

                       </AccordionDetails>
                     </Accordion>
                   })
                 }
               </div>
             </div>
           </div>
         </div>
       {/*</div>*/}
     </>
  )
}
